import React from 'react';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function Pricing() {
  const plans = [{
    name: 'Starter',
    price: '299 €',
    prefix: 'ab',
    features: ['3 Visualisierungen', '1 Revision', '72h Lieferung', 'Standard Auflösung'],
    cta: 'Auswählen',
    highlighted: false
  }, {
    name: 'Pro',
    price: '799 €',
    prefix: 'ab',
    features: ['10 Visualisierungen', '3 Revisionen', '48h Lieferung', '4K Auflösung', 'Kommerzielle Nutzung'],
    cta: 'Auswählen',
    highlighted: true
  }, {
    name: 'Studio',
    price: 'auf Anfrage',
    prefix: '',
    features: ['Unbegrenzte Visuals', 'Dedizierter Ansprechpartner', 'Priority Support', 'Custom Branding', 'API Zugriff'],
    cta: 'Kontaktieren',
    highlighted: false
  }];
  return <section id="pricing" className="py-24 bg-[#111113]" data-id="element-125">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-126">
        <div className="text-center mb-16" data-id="element-127">
          <h2 className="text-3xl sm:text-4xl font-semibold text-white mb-4" data-id="element-128">
            Preise & Pakete
          </h2>
          <p className="font-light text-zinc-400" data-id="element-129">
            Transparente Kosten für Projekte jeder Größe.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 items-start" data-id="element-130">
          {plans.map(plan => <div key={plan.name} className={`relative p-8 rounded-2xl transition-all duration-300 ${plan.highlighted ? 'glass-card bg-white/[0.06] ring-1 ring-blue-500/30 scale-105 z-10' : 'glass-card hover:bg-white/[0.04]'}`} data-id="element-131">
              {plan.highlighted && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-132">
                  Beliebt
                </div>}

              <div className="mb-8" data-id="element-133">
                <h3 className="text-lg font-medium text-white mb-2" data-id="element-134">
                  {plan.name}
                </h3>
                <div className="flex items-baseline gap-1" data-id="element-135">
                  {plan.prefix && <span className="text-sm text-zinc-500" data-id="element-136">{plan.prefix}</span>}
                  <span className="text-4xl font-semibold text-white" data-id="element-137">
                    {plan.price}
                  </span>
                </div>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-138">
                {plan.features.map(feature => <li key={feature} className="flex items-start gap-3" data-id="element-139">
                    <Check className="w-5 h-5 text-blue-400 flex-shrink-0" data-id="element-140" />
                    <span className="font-light text-zinc-400 text-sm" data-id="element-141">
                      {feature}
                    </span>
                  </li>)}
              </ul>

              <Button fullWidth variant={plan.highlighted ? 'primary' : 'secondary'} onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-142">
                {plan.cta}
              </Button>
            </div>)}
        </div>
      </div>
    </section>;
}